<template>
<div>
    <h1>Client·e·s</h1>
    <DialogView v-model:visible="displayCalendar" style="width:100%">
      <CalendarView :contextualClient="store.currentClientFile" :appointmentEdit="appEdited" @closeModal="closeModalAndReload"/>
    </DialogView>


    <DialogView v-model:visible="confirmDelete" style="width:60%; text-align:center" :keepInViewport="false">
    <h2>Voulez-vous supprimer le rendez-vous?</h2>
    Les données liés à ce rendez-vous seront supprimées complètement
      <template #footer>
              <InputButton @click="deleteAppointment">Oui</InputButton>
              <InputButton @click="confirmDelete=false">Non</InputButton>
            </template>
    </DialogView>

    <DialogView v-model:visible="mergeOngoing" style="width:min(680px, 95%)" :keepInViewport="false">
    <template #header><h3 class="mergeDialogTitle">Fusionner deux dossiers</h3></template>

    <GridLoader v-if="clientsLoading" class="loader"></GridLoader>

    <div v-if="!clientsLoading" class="mergeBody">
      <div class="mergeWarning">
        <i class="pi pi-exclamation-triangle"></i>
        <span>Tous les rendez-vous du dossier supprimé seront transférés vers le dossier conservé. Les données personnelles du dossier supprimé seront définitivement effacées.</span>
      </div>

      <div class="mergeColumns">
        <div class="mergeCard mergeCardDelete">
          <div class="mergeCardHeader">
            <i class="pi pi-trash"></i>
            <span>Sera supprimé</span>
          </div>
          <div class="mergeField"><span class="mergeLabel">Nom</span><span class="mergeValue">{{client.lastname}}</span></div>
          <div class="mergeField"><span class="mergeLabel">Prénom</span><span class="mergeValue">{{client.firstname}}</span></div>
          <div class="mergeField"><span class="mergeLabel">Téléphone</span><span class="mergeValue">{{client.phone || '-'}}</span></div>
          <div class="mergeField"><span class="mergeLabel">Adresse</span><span class="mergeValue">{{client.address || '-'}}</span></div>
          <div class="mergeField" v-if="client.comment"><span class="mergeLabel">Commentaire</span><span class="mergeValue">{{client.comment}}</span></div>
          <div class="mergeStats">
            <span class="mergeStat"><i class="pi pi-history"></i> {{ currentClientPastCount }} passés</span>
            <span class="mergeStat"><i class="pi pi-calendar"></i> {{ currentClientFutureCount }} futurs</span>
          </div>
        </div>

        <div class="mergeArrow"><i class="pi pi-arrow-right"></i></div>

        <div class="mergeCard mergeCardKeep">
          <div class="mergeCardHeader">
            <i class="pi pi-check-circle"></i>
            <span>Sera conservé</span>
          </div>
          <div class="mergeSearchRow">
            <AutoComplete ref="searchbar" v-model="selectedClientToMergeInto" :suggestions="filteredClients" @item-select="loadClientData" @complete="searchClient($event)" autoHighlight field="name" inputStyle="width: 100%" class="mergeSearchInput" placeholder="Rechercher un client..."/>
            <InputButton icon="pi pi-times" class="p-button-text p-button-rounded p-button-sm" @click="empty"/>
          </div>
          <template v-if="selectedClientToMergeIntoData">
            <div class="mergeField"><span class="mergeLabel">Nom</span><span class="mergeValue">{{selectedClientToMergeIntoData.lastname}}</span></div>
            <div class="mergeField"><span class="mergeLabel">Prénom</span><span class="mergeValue">{{selectedClientToMergeIntoData.firstname}}</span></div>
            <div class="mergeField"><span class="mergeLabel">Téléphone</span><span class="mergeValue">{{selectedClientToMergeIntoData.phone || '-'}}</span></div>
            <div class="mergeField"><span class="mergeLabel">Adresse</span><span class="mergeValue">{{selectedClientToMergeIntoData.address || '-'}}</span></div>
            <div class="mergeField" v-if="selectedClientToMergeIntoData.comment"><span class="mergeLabel">Commentaire</span><span class="mergeValue">{{selectedClientToMergeIntoData.comment}}</span></div>
            <div class="mergeStats">
              <span class="mergeStat"><i class="pi pi-history"></i> {{ mergeTargetPastCount }} passés</span>
              <span class="mergeStat"><i class="pi pi-calendar"></i> {{ mergeTargetFutureCount }} futurs</span>
            </div>
          </template>
          <div v-else class="mergePlaceholder">Sélectionnez le dossier à conserver</div>
        </div>
      </div>
    </div>

      <template #footer>
              <InputButton label="Annuler" icon="pi pi-times" class="p-button-text" @click="mergeOngoing=false" :disabled="mergeInProgress"/>
              <InputButton label="Confirmer la fusion" icon="pi pi-check" class="p-button-danger" @click="confirmMerge" :disabled="mergeInProgress || !selectedClientToMergeIntoData"/>
      </template>
    </DialogView>
    
    
    <GridLoader v-if="clientsLoading" class="loader"></GridLoader>

    <!-- List all clients  -->
    <div v-if="store.currentClientFile == 0" class="allClientsGrid">
      <div class="card">

      <DataTable :value="allClients" selectionMode="single"  @rowSelect="clientSelected" v-model:selection="selectedClient"
        :paginator="true" :rows="10">
    <DataTableColumn field="name" header="Nom"><template #body="{data}">{{data.name}}</template></DataTableColumn>
    <DataTableColumn field="phone" header="Téléphone"><template #body="{data}">{{data.phone}}</template></DataTableColumn>
    <DataTableColumn field="id" header="Numéro de client"><template #body="{data}">{{data.clientNumber}}</template></DataTableColumn>

</DataTable>
      </div>
    </div>

    <div v-else class="clientFile">
      <!-- Top bar -->
      <div class="clientTopBar">
        <button class="backBtn" @click="closeClient"><i class="pi pi-arrow-left"></i> Tous les clients</button>
        <div class="clientTopBarRight">
          <InputButton @click="makeAppointment" class="p-button-success p-button-sm" label="Nouveau RDV" icon="pi pi-calendar"/>
          <InputButton @click="mergeClient" class="p-button-text p-button-sm p-button-secondary" icon="pi pi-directions" v-tooltip="'Fusionner avec un autre dossier'"/>
        </div>
      </div>

      <!-- Client name header -->
      <div class="clientNameHeader">
        <h2>{{client.firstname}} {{client.lastname}}</h2>
        <span v-if="client.phone" class="clientPhoneTag"><i class="pi pi-phone"></i> {{client.phone}}</span>
      </div>

      <div class="clientFileGrid">
        <!-- Left column: personal data -->
        <div class="card clientDataCard">
          <h3>Données personnelles</h3>
          <GridLoader v-if="clientUpdating" class="loader"></GridLoader>
          <div class="clientForm">
            <div class="clientFormRow">
              <label for="lastname">Nom</label>
              <InputText id="lastname" v-model="client.lastname" type="text"/>
            </div>
            <div class="clientFormRow">
              <label for="firstname">Prénom</label>
              <InputText id="firstname" v-model="client.firstname" type="text"/>
            </div>
            <div class="clientFormRow">
              <label for="phone">Téléphone</label>
              <InputMask id="phone" mask="999/999.99.99" unmask v-model="client.phone" type="text"/>
            </div>
            <div class="clientFormRow">
              <label for="adress">Adresse</label>
              <InputText id="adress" v-model="client.address" type="text"/>
            </div>
            <div class="clientFormRow clientFormRowFull">
              <label for="clientComment">Commentaire</label>
              <TextArea id="clientComment" v-model="client.comment" type="text" rows="3" />
            </div>
          </div>
          <InputButton @click="saveClient" class="p-button-success p-button-sm" label="Sauvegarder" icon="pi pi-save" style="margin-top: 0.6rem"/>
        </div>

        <!-- Right column: upcoming appointments -->
        <div class="card clientUpcomingCard">
          <h3>Prochains rendez-vous</h3>
          <GridLoader v-if="nextAppointmentsLoading" class="loader"></GridLoader>
          <div v-if="!nextAppointmentsLoading && clientNextAppointments.length === 0" class="emptyUpcoming">Aucun rendez-vous à venir</div>
          <div class="upcomingList">
            <div class="upcomingItem" v-for="app in clientNextAppointments" :key="app.appid">
              <div class="upcomingMain">
                <div class="upcomingDate">{{getNiceDate(app.start)}} à {{getNiceTime(app.start)}}</div>
                <div class="upcomingMeta">
                  <span>{{writeMinutes(app.duration)}}</span>
                  <span v-if="appointmentServiceText(app)">{{appointmentServiceText(app)}}</span>
                </div>
                <div v-if="appointmentHairText(app)" class="upcomingHair">{{appointmentHairText(app)}}</div>
              </div>
              <div class="upcomingActions">
                <InputButton icon="pi pi-send" class="p-button-text p-button-sm p-button-secondary" @click="resendSms(app)" :disabled="resendingSmsAppId === app.appid" v-tooltip="'Renvoyer SMS'"/>
                <InputButton icon="pi pi-calendar" class="p-button-text p-button-sm p-button-secondary" @click="goToAgenda(app.start)" v-tooltip="'Agenda'"/>
                <InputButton icon="pi pi-pencil" class="p-button-text p-button-sm p-button-secondary" @click="edit(app.appid, app.start)" v-tooltip="'Déplacer'"/>
                <InputButton icon="pi pi-trash" class="p-button-text p-button-sm p-button-danger" @click="askDelete(app.appid)" v-tooltip="'Supprimer'"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Full-width: all appointments -->
      <div class="card">
        <h3>Historique des rendez-vous</h3>
        <AppointmentListView :appointments="pastAppointments" :listItemName="itemName" @app-updated="loadClient()"/>
      </div>
    </div>
    </div>

</template>


<style scoped>
.clientFile {
  display: grid;
  gap: 14px;
}

.clientTopBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.backBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #475569;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.12s;
}

.backBtn:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.backBtn i {
  font-size: 0.85rem;
}

.clientTopBarRight {
  display: flex;
  align-items: center;
  gap: 6px;
}

.clientNameHeader {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
}

.clientNameHeader h2 {
  margin: 0;
  font-size: 1.3rem;
  color: #0f172a;
}

.clientPhoneTag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 0.82rem;
  color: #475569;
}

.clientPhoneTag i {
  font-size: 0.78rem;
}

.clientFileGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.clientDataCard h3,
.clientUpcomingCard h3 {
  margin: 0 0 10px 0;
  font-size: 1rem;
}

.clientForm {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}

.clientFormRow {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.clientFormRow label {
  font-size: 0.82rem;
  color: #64748b;
}

.clientFormRowFull {
  grid-column: 1 / -1;
}

.emptyUpcoming {
  color: #94a3b8;
  font-size: 0.9rem;
  padding: 8px 0;
}

.upcomingList {
  display: grid;
  gap: 8px;
}

.upcomingItem {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fafcff;
}

.upcomingDate {
  font-weight: 600;
  font-size: 0.92rem;
  color: #1e293b;
}

.upcomingMeta {
  display: flex;
  gap: 8px;
  font-size: 0.82rem;
  color: #64748b;
  margin-top: 2px;
}

.upcomingHair {
  font-size: 0.8rem;
  color: #94a3b8;
  margin-top: 2px;
}

.upcomingActions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}

@media (max-width: 900px) {
  .clientFileGrid {
    grid-template-columns: 1fr;
  }

  .clientForm {
    grid-template-columns: 1fr;
  }

  .clientTopBar {
    flex-direction: column;
    align-items: flex-start;
  }
}

.mergeDialogTitle {
  margin: 0;
  font-size: 1.1rem;
}

.mergeBody {
  text-align: left;
}

.mergeWarning {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  background: #fff8ee;
  border: 1px solid #f0d9bf;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.88rem;
  color: #7a5010;
  line-height: 1.45;
}

.mergeWarning i {
  color: #d4880f;
  margin-top: 2px;
  flex-shrink: 0;
}

.mergeColumns {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0.75rem;
  align-items: start;
}

.mergeArrow {
  display: flex;
  align-items: center;
  padding-top: 2.5rem;
  color: #94a3b8;
  font-size: 1.1rem;
}

.mergeCard {
  border: 1px solid #e2e9f5;
  border-radius: 10px;
  padding: 0.75rem 0.9rem;
  background: #ffffff;
}

.mergeCardDelete {
  border-color: #f1c8c8;
  background: #fffafa;
}

.mergeCardKeep {
  border-color: #b8dab5;
  background: #f8fcf8;
}

.mergeCardHeader {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 700;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0.6rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #eef1f6;
}

.mergeCardDelete .mergeCardHeader {
  color: #9b2c2c;
  border-color: #f5dada;
}

.mergeCardKeep .mergeCardHeader {
  color: #2d6a2e;
  border-color: #d4ecd3;
}

.mergeField {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.35rem 0;
  font-size: 0.9rem;
}

.mergeField + .mergeField {
  border-top: 1px dashed #edf1f6;
}

.mergeLabel {
  color: #64748b;
  flex-shrink: 0;
}

.mergeValue {
  color: #1e293b;
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

.mergeSearchRow {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}

.mergeSearchInput {
  flex: 1;
  min-width: 0;
}

.mergeStats {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e8edf5;
}

.mergeStat {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.82rem;
  color: #475569;
  font-weight: 600;
}

.mergeStat i {
  font-size: 0.85rem;
  color: #94a3b8;
}

.mergePlaceholder {
  color: #94a3b8;
  font-size: 0.88rem;
  padding: 0.75rem 0;
  text-align: center;
}

@media (max-width: 640px) {
  .mergeColumns {
    grid-template-columns: 1fr;
  }

  .mergeArrow {
    justify-content: center;
    padding: 0;
  }

  .mergeArrow i {
    transform: rotate(90deg);
  }
}

::v-deep(.row-notclosed) {
  background-color:salmon !important;
}


</style>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import axios from 'axios'
import { authHeader } from '../helpers/authHeader.js';
import { useMainStore } from '../store';
import { getNiceDate, getNiceTime, writeMinutes} from  '../dateUtils.js';
import { useRouter, useRoute } from 'vue-router';
import CalendarView from './CalendarView.vue';
import AppointmentListView from './AppointmentListView.vue';
import { parseStructuredAppointmentDetails, structuredHairSummary, structuredServiceSummary } from '../helpers/appointmentDisplay.js';

const mergeOngoing = ref(false);

const itemName = "rendez-vous pour ce·tte client·e";

const displayCalendar = ref(false);

const nextAppointmentsLoading = ref(false);
const clientNextAppointments = ref([]);

const appEdited = ref(null);

const appsLoading = ref(false);
const appointments = ref([]);

const pastAppointments = computed(() => {
  const now = new Date();
  return (appointments.value || []).filter(a => {
    const d = new Date(String(a.start || '').replace(' ', 'T'));
    return !isNaN(d) && d < now;
  });
});

const clientLoading = ref(false);
const client = ref({firstname:"", lastname:"", phone:"", address:"", comment: ""});

const store = useMainStore();
const router = useRouter();
const route = useRoute();

const clientUpdating = ref(false);

const confirmDelete = ref(false);
const appToDelete = ref(null);
const mergeInProgress = ref(false);

const allClients = ref([]);
const clientsLoading = ref(false);

const selectedClientToMergeInto = ref(null);
const selectedClientToMergeIntoData = ref(null);
const mergeTargetApps = ref([]);

const currentClientPastCount = computed(() => {
  const now = new Date();
  return (appointments.value || []).filter(a => {
    const d = new Date(String(a.start || '').replace(' ', 'T'));
    return !isNaN(d) && d < now;
  }).length;
});

const currentClientFutureCount = computed(() => {
  const now = new Date();
  return (appointments.value || []).filter(a => {
    const d = new Date(String(a.start || '').replace(' ', 'T'));
    return !isNaN(d) && d >= now;
  }).length;
});

const mergeTargetPastCount = computed(() => {
  const now = new Date();
  return mergeTargetApps.value.filter(a => {
    const d = new Date(String(a.start || '').replace(' ', 'T'));
    return !isNaN(d) && d < now;
  }).length;
});

const mergeTargetFutureCount = computed(() => {
  const now = new Date();
  return mergeTargetApps.value.filter(a => {
    const d = new Date(String(a.start || '').replace(' ', 'T'));
    return !isNaN(d) && d >= now;
  }).length;
});

const selectedClient = ref(null);



onMounted(() => {
   const mergeFrom = Number(route.query.mergeFrom || 0);
   const mergeInto = Number(route.query.mergeInto || 0);

   if (mergeFrom > 0 && mergeInto > 0 && mergeFrom !== mergeInto) {
    store.$patch((state) => {
      state.currentClientFile = String(mergeFrom);
    });
    loadClient();
    mergeClient(mergeInto);
    router.replace({ path: '/clients' });
    return;
   }

   if(store.currentClientFile != 0) {
    loadClient();
   }
   else
   {
    loadClients();
   }
 });

 watch(() => store.currentClientFile, (newVal, oldVal) => {
   if (newVal != 0 && newVal != oldVal) {
     loadClient();
   }
 });

 


function loadClients()
{
    console.log("loading all clients ! ");
      var options = {
        "headers" :  authHeader()
      };
    clientsLoading.value = true;

axios
      .get(`${process.env.VUE_APP_API_URL}/Clients`, options)
      .then(response => {
          allClients.value = response.data;
          clientsLoading.value = false;
 });
}

function clientSelected()
{
  store.$patch((state) => {
              state.currentClientFile = selectedClient.value.clientid;
          });
          loadClient();
}


function confirmMerge()
{
      if (!selectedClientToMergeInto.value || !selectedClientToMergeInto.value.clientid) {
        alert("Veuillez sélectionner un dossier à conserver.");
        return;
      }

      if (String(selectedClientToMergeInto.value.clientid) === String(store.currentClientFile)) {
        alert("Le dossier conservé doit être différent du dossier fusionné.");
        return;
      }

      if (mergeInProgress.value) {
        return;
      }

      mergeInProgress.value = true;

      var options = {
        "headers" :  authHeader()
      };

      var json = JSON.stringify({});

      const keepClientId = selectedClientToMergeInto.value.clientid;

  axios
      .post(`${process.env.VUE_APP_API_URL}/Clients/merge?mergeClientId=${store.currentClientFile}&keepClientId=${keepClientId}`, json, options)
      .then(() => {
          mergeInProgress.value = false;
          mergeOngoing.value = false;
          store.$patch((state) => {
              state.currentClientFile = keepClientId;
          });
          // loadClient() will be triggered by the watch on currentClientFile
      })
      .catch((reason) => {
          mergeInProgress.value = false;
          console.log(reason);
          alert("Erreur lors de la fusion des dossiers.");
      });
}

function loadClientData()
{
      if (!selectedClientToMergeInto.value || !selectedClientToMergeInto.value.clientid) {
        return;
      }

      clientsLoading.value = true;
      mergeTargetApps.value = [];

      var options = {
        "headers" :  authHeader()
      };

      const targetId = selectedClientToMergeInto.value.clientid;

  Promise.all([
      axios.get(`${process.env.VUE_APP_API_URL}/Clients/getById?clientId=${targetId}`, options),
      axios.get(`${process.env.VUE_APP_API_URL}/Appointments/getForClient?clientId=${targetId}`, options)
  ])
      .then(([clientResponse, appsResponse]) => {
          clientsLoading.value = false;
          selectedClientToMergeIntoData.value = clientResponse.data;
          mergeTargetApps.value = appsResponse.data || [];
      })
      .catch(() => {
          clientsLoading.value = false;
      });

}

function askDelete(id)
{
  appToDelete.value = id;
  confirmDelete.value = true;
}

function mergeClient(preselectedKeepClientId = null)
{
  selectedClientToMergeInto.value = null;
  selectedClientToMergeIntoData.value = null;
  mergeOngoing.value = true;
  clientsLoading.value = true;

     var options = {
        "headers" :  authHeader()
      };

axios
      .get(`${process.env.VUE_APP_API_URL}/Clients`, options)
      .then(response => {
          clientsLoading.value = false;
          allClients.value = response.data;

          if (preselectedKeepClientId != null) {
            const keepClient = allClients.value.find(c => String(c.clientid) === String(preselectedKeepClientId));
            if (keepClient && String(keepClient.clientid) !== String(store.currentClientFile)) {
              selectedClientToMergeInto.value = keepClient;
              loadClientData();
            }
          }

 });

}

const filteredClients = ref([]);


function empty() {
  filteredClients.value = [];
  selectedClientToMergeInto.value = null;
  selectedClientToMergeIntoData.value = null;
  mergeTargetApps.value = [];
}


function searchClient(event)
{
        const safe = (allClients.value || []).filter(c => c && c.name && c.clientid != store.currentClientFile);
        if (!event.query.trim().length) {
                    filteredClients.value = [...safe];
                }
                else {
                    const query = event.query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                    filteredClients.value = safe.filter((client) => {
                        return client.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(query);
                    });
                }

}




function deleteAppointment()
{

  var options = {
    "headers" :  authHeader()
      };

            var json = JSON.stringify({});


    axios
      .post(`${process.env.VUE_APP_API_URL}/Appointments/deleteappointment?appid=${appToDelete.value}`, json, options)
      .then(() => {
        confirmDelete.value = false;
      appToDelete.value = null;
        loadNextAppointments();
        loadClient();
      })
      .catch(reason => {
          console.log(reason);
          alert("error");
      });
}


function goToAgenda(date)
{          
  store.$patch((state) => {
              state.loadDate = date;
  });

    router.push('agenda');
}

function loadNextAppointments()
{
    nextAppointmentsLoading.value = true;
    clientNextAppointments.value = [];

      var options = {
        "headers" :  authHeader()
      };

      axios
      .get(`${process.env.VUE_APP_API_URL}/Appointments/getForClient?clientId=${store.currentClientFile}&onlyFuture=true`, options)
      .then(response => {
          clientNextAppointments.value = response.data;
          nextAppointmentsLoading.value = false;
      });
}

function closeModalAndReload()
{
  displayCalendar.value = false;
  loadNextAppointments();
  loadClient();
}

function makeAppointment()
{
  appEdited.value = null;
  displayCalendar.value = true;
}

function closeClient()
{
  store.$patch((state) => {
              state.currentClientFile = 0
  });
  loadClients();
}

function edit(id, start)
{
  appEdited.value = id;
  if (start) {
    store.$patch((state) => {
      state.loadDate = start;
    });
  }
  displayCalendar.value = true;
}

function loadClient()
{

    appsLoading.value = true;
    clientLoading.value = true;

      var options = {
        "headers" :  authHeader()
      };


    axios
      .get(`${process.env.VUE_APP_API_URL}/Appointments/getForClient?clientId=${store.currentClientFile}`, options)
      .then(response => {
          appsLoading.value = false;
          appointments.value = response.data;
 });

  axios
      .get(`${process.env.VUE_APP_API_URL}/Clients/getById?clientId=${store.currentClientFile}`, options)
      .then(response => {
          clientLoading.value = false;
          client.value = response.data;
 });

  loadNextAppointments();
}

function appointmentServiceText(app) {
  const structured = parseStructuredAppointmentDetails(app?.details);
  if (structured) {
    return structuredServiceSummary(structured);
  }
  return app?.serviceComments || app?.details || "";
}

function appointmentHairText(app) {
  const structured = parseStructuredAppointmentDetails(app?.details);
  if (!structured) {
    return "";
  }
  return structuredHairSummary(structured);
}


const resendingSmsAppId = ref(null);

function resendSms(app) {
  if (!app || !app.appid) return;
  if (!window.confirm("Renvoyer le SMS de confirmation pour ce rendez-vous ?")) return;

  resendingSmsAppId.value = app.appid;

  axios
    .post(`${process.env.VUE_APP_API_URL}/Appointments/resendConfirmationSms?appid=${app.appid}`, JSON.stringify({}), { headers: authHeader(true) })
    .then(() => {
      resendingSmsAppId.value = null;
      alert("SMS de confirmation renvoyé.");
    })
    .catch((reason) => {
      resendingSmsAppId.value = null;
      console.log(reason);
      alert("Impossible d'envoyer le SMS.");
    });
}

function saveClient()
{
    var clientData = client.value;

    var json = JSON.stringify(clientData);

     var options = {
        "headers" :  authHeader(true)
      };


        clientUpdating.value = true;

        axios
      .post(`${process.env.VUE_APP_API_URL}/Clients?clientId=${store.currentClientFile}`, json, options)
      .then(() => {
          clientUpdating.value = false;
      })
      .catch(reason => {
          console.log(reason);
          alert("error");
      });
}


</script>
